export function normalizeGreetingFileMetadata(data) {
    if (!data || typeof data !== 'object') {
        return null;
    }
    const row = data;
    const idRaw = row.id ?? row.fileId;
    const id = typeof idRaw === 'number' ? idRaw : Number(idRaw);
    if (!Number.isFinite(id) || id <= 0) {
        return null;
    }
    const nameRaw = row.originalFileName ?? row.filename ?? row.name;
    const originalFileName = typeof nameRaw === 'string' && nameRaw.trim() ? nameRaw.trim() : 'greeting';
    const sizeRaw = row.sizeBytes ?? row.size;
    const sizeBytes = typeof sizeRaw === 'number' && Number.isFinite(sizeRaw)
        ? sizeRaw
        : typeof sizeRaw === 'string' && sizeRaw.trim()
            ? Number(sizeRaw)
            : undefined;
    return {
        id,
        originalFileName,
        contentType: typeof row.contentType === 'string' ? row.contentType : undefined,
        sizeBytes: sizeBytes != null && Number.isFinite(sizeBytes) ? sizeBytes : undefined,
        category: typeof row.category === 'string' ? row.category : undefined,
        uploadedBy: typeof row.uploadedBy === 'string' ? row.uploadedBy : undefined,
        createdAt: typeof row.createdAt === 'string' ? row.createdAt : undefined,
    };
}
export function formatGreetingCreatedAt(iso) {
    if (!iso?.trim()) {
        return '—';
    }
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
        return iso;
    }
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    });
}
